export class Address {
  id?: number;
  company?: string;
  name?: string;
  line1?: string;
  line2?: string;
  line3?: string;
  line4?: string;
  line5?: string;
  line6?: string;
  city?: string;
  country?: string;
  isoCode?: string;
  state?: string;
  zipCode?: string;
  phonenumber?: string;
}
